<template>
    <nav class="flex items-center p-4 border-b border-gray-200 bg-gray-100">
        <button
            class="flex-1 px-3 py-3 text-center | transition duration-300 hover:text-gray-900"
            :class="{ 'rounded shadow-lg text-blue-500 bg-white transform-none hover:text-blue-500': value == tab.value }"
            :key="tab.value"
            @click="$emit('input', tab.value)"
            v-for="tab in filteredTabs"
        >
            {{ tab.text }}
        </button>
    </nav>
</template>

<script>
    export default {
        props: {
            tabs: {
                type: Array,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
        },

        computed: {
            filteredTabs() {
                return this.tabs.filter(tab => {
                    return typeof tab.condition === 'undefined' || !!tab.condition;
                });
            },
        },
    };
</script>
